import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { doc, getDoc } from "firebase/firestore";
import { db } from '../firebaseConfig.js';
import Menu from '../components/Menu.js';
import VacantesSlider from "../components/VacantesSlider.js";
import ServiceRequestForm from "../components/ServiceRequestForm.js";
import SolicitudesServiciosSlider from '../components/SolicitudesServiciosSlider.js';
// Importar las imágenes desde la carpeta assets
import portada1 from '../assets/portada1.jpeg';
import portada2 from '../assets/portada2.jpeg';
import portada3 from '../assets/portada3.jpeg';
import './HomePage.css';

// Imágenes de ejemplo para el slider
const sliderImages = [portada1, portada2, portada3];
const sliderTitles = ["Contratá a los mejores profesionales", "Ofrecé tus servicios", "Creá tu curriculum fácil, rápido y destacá"];

const HomePage = () => {
  const { currentUser } = useAuth();
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isProfileIncomplete, setIsProfileIncomplete] = useState(false);
  const navigate = useNavigate();

  // Cambiar la imagen del slider cada 5 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

   // Verificar si los datos del usuario están completos
   useEffect(() => {
    const checkUserProfile = async () => {
      if (currentUser) {
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          const { fullName, phoneNumber, country, state, city, address } = userDoc.data();
          if (!fullName || !phoneNumber || !country || !state || !city || !address) {
            setIsProfileIncomplete(true);
          }
        }
      }
    };

    checkUserProfile();
  }, [currentUser]);

  // Manejo del envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Enviando datos:', { category, description });
    alert('Su solicitud ha sido enviada.');
    setCategory('');
    setDescription('');
  };

  return (
    <div className="vp-container">
      <Menu />
      <div className="vp-main-content">
        <div className="homepage">
          {/* Slider */}
          <div className="slider-container-h">
            {sliderImages.map((image, index) => (
              <div
                key={index}
                className={`slider-slide ${
                  index === currentSlide
                    ? 'active'
                    : index === (currentSlide - 1 + sliderImages.length) % sliderImages.length
                    ? 'prev'
                    : 'next'
                }`}
              >
                <div className="slider-overlay">
                  <h1 className="slider-title">{sliderTitles[index]}</h1>
                </div>
                <img src={image} alt={`Slide ${index}`} className="slider-image" />
              </div>
            ))}
          </div>

          {/* Vacantes */}
          <VacantesSlider />

          {/* Solicitudes */}
          <SolicitudesServiciosSlider />

            {/* Mensaje para completar datos de perfil */}
            {isProfileIncomplete && (
            <div className="profile-warning">
              <p>
                Completa los datos de tu cuenta para poder usar Apimys con normalidad. 
                <span 
                  className="link-cuenta" 
                  onClick={() => navigate('/cuenta')}
                >
                  Cuenta
                </span>
              </p>
            </div>
          )}

          {/* Formulario */}
          <ServiceRequestForm />

          {/* Botones de inicio de sesión y registro si el usuario no está autenticado */}
          {!currentUser && (
            <div className="conLog">
              <p>Inicia sesión o registrate fácilmente si no tenés cuenta.</p>
              <div className="loginContainer">
                <ul>
                  <Link to="/Login"> <li className="login">Inicio</li> </Link>
                  <Link to="/Register"><li className="registro">Registro</li> </Link>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
